import crypto from 'crypto';

export function encrypt(data) {
  try {
    const key = '0123456789abcdef0123456789abcdef0123456789abcdef0123456789abcdef';
    const iv = '0123456789abcdef0123456789abcdef';

    if (!key || !iv) {
      throw new Error('Encryption key or IV not provided in environment variables');
    }

    if (!/^[0-9a-f]{64}$/i.test(key)) {
      throw new Error('ENCRYPTION_KEY must be a 32-byte (64 hex character) string');
    }

    if (!/^[0-9a-f]{32}$/i.test(iv)) {
      throw new Error('ENCRYPTION_IV must be a 16-byte (32 hex character) string');
    }

    const keyBuffer = Buffer.from(key, 'hex');
    const ivBuffer = Buffer.from(iv, 'hex');

    // Eğer data string değilse, JSON'a çevir
    const plainText = typeof data === 'string' ? data : JSON.stringify(data);

    const cipher = crypto.createCipheriv('aes-256-cbc', keyBuffer, ivBuffer);

    let encrypted = cipher.update(plainText, 'utf8', 'hex');
    encrypted += cipher.final('hex');

    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error.message);
    throw error;
  }
}

export function decrypt(encryptedData) {
  try {
    const key = process.env.VUE_APP_ENCRYPTION_KEY || '';
    const iv = process.env.VUE_APP_ENCRYPTION_IV || '';

    if (!key || !iv) {
      throw new Error('Encryption key or IV not provided in environment variables');
    }

    if (!/^[0-9a-f]{64}$/i.test(key)) {
      throw new Error('ENCRYPTION_KEY must be a 32-byte (64 hex character) string');
    }

    if (!/^[0-9a-f]{32}$/i.test(iv)) {
      throw new Error('ENCRYPTION_IV must be a 16-byte (32 hex character) string');
    }

    const keyBuffer = Buffer.from(key, 'hex');
    const ivBuffer = Buffer.from(iv, 'hex');

    const decipher = crypto.createDecipheriv('aes-256-cbc', keyBuffer, ivBuffer);

    let decrypted = decipher.update(encryptedData, 'hex', 'utf8');
    decrypted += decipher.final('utf8');

    // Eğer JSON formatında ise, parse et
    try {
      console.log('Decrypted data:', JSON.parse(decrypted));
      return JSON.parse(decrypted);
    } catch (e) {
      return decrypted; // Eğer JSON değilse, düz metin olarak döndür
    }
  } catch (error) {
    console.error('Decryption error:', error.message);
    throw error;
  }
}